<template>
  <v-container grid-list-xl class="pa-0">
    <v-row wrap>
      <v-col cols="12">
        <FilterPengurus @filter="filter" class="px-5" />
        <v-row class="ml-2">
          <v-col cols="12" sm="6" md="4" lg="4">
            <BlockCard title="Persentase Perempuan (%)" :value="item.persen_perempuan" icon="mdi-percent" color="#F48C6C" />
          </v-col>
        </v-row>
        <v-row class="mx-3">
          <v-col cols="12" class="ml-3" v-if="openfilter.includes(current_user.lingkup.tingkat)">
            <v-menu bottom offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn href="" v-bind="attrs" v-on="on" class="elevation-7 text-capitalize white--text amber darken-1">
                  UNDUH <v-icon class="ml-2" small color="white">mdi-arrow-down-drop-circle-outline</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="rekapKota">
                  <v-list-item-title class=" purple--text text--darken-4">REKAP KOTA</v-list-item-title>
                </v-list-item>
                <v-list-item @click="rekapKecamatan">
                  <v-list-item-title class=" purple--text text--darken-4">REKAP KECAMATAN</v-list-item-title>
                </v-list-item>
                <v-list-item @click="downloadKTPKTA">
                  <v-list-item-title class=" purple--text text--darken-4">REKAP KTP KTA </v-list-item-title>
                </v-list-item>

                <v-list-item @click="cetakZIP('pusat')" v-show="openfilter.includes(current_user.lingkup.tingkat) && !filtered.propinsi_id">
                  <v-list-item-title class=" purple--text text--darken-4">ZIP Pusat</v-list-item-title>
                </v-list-item>
                <v-list-item @click="cetakZIP('propinsi')" v-show="openfilter.includes(current_user.lingkup.tingkat)">
                  <v-list-item-title class=" purple--text text--darken-4">ZIP Propinsi</v-list-item-title>
                </v-list-item>
                <v-list-item @click="cetakZIP('kota')" v-show="openfilter.includes(current_user.lingkup.tingkat)">
                  <v-list-item-title class=" purple--text text--darken-4">ZIP Kota</v-list-item-title>
                </v-list-item>
                <v-list-item @click="cetakZIP('kecamatan')" v-show="openfilter.includes(current_user.lingkup.tingkat)">
                  <v-list-item-title class=" purple--text text--darken-4">ZIP Kecamatan</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>
          <v-col cols="12" class="ml-3" v-else>
            <v-menu bottom offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn href="" v-bind="attrs" v-on="on" class="elevation-7 text-capitalize white--text amber darken-1">
                  UNDUH <v-icon class="ml-2" small color="white">mdi-arrow-down-drop-circle-outline</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="downloadKTPKTA">
                  <v-list-item-title class=" purple--text text--darken-4">REKAP KTP KTA</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>
          <v-col cols="12" class="mb-0 pb-0 title">{{ item.keterangan }}</v-col>
          <v-col cols="12" sm="12" md="4" lg="4" v-for="o in item.jabatan" :key="o.index">
            <v-card class="mx-auto mb-3 text-center flexcard" style="height:100%">
              <template slot="progress">
                <v-progress-linear color="deep-purple" height="10" indeterminate></v-progress-linear>
              </template>

              <v-img contain height="250" :src="o.pejabat && o.pejabat.warga && o.pejabat.warga.foto ? o.pejabat.warga.foto.pas_foto : 'img/no-image.jpeg'"></v-img>

              <div class="text-center caption pb-0 mb-0 mx-3 font-weight-bold amber rounded mt-4 pa-1">{{ o.keterangan }}</div>

              <v-card-text class="body-1 grow">
                <div :class="o.pejabat ? 'black--text' : 'error--text'">{{ o.pejabat && o.pejabat.warga ? o.pejabat.warga.nama : "Belum disetting" }}</div>
              <div> <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
          <span
            v-bind="attrs"
            v-on="on"
          >{{ o.pejabat && o.pejabat.warga ? cekStatus(o.pejabat.warga.is_daftar) : "Belum terdaftar" }}</span>
                </template>
                <span>{{ o.pejabat && o.pejabat.warga ? o.pejabat.warga.partai : "-" }}</span>
              </v-tooltip></div>
              </v-card-text>

              <v-divider class="mx-4"></v-divider>

              <v-card-actions class="grey lighten-3" style="margin-bottom:0">
                <v-spacer></v-spacer>
                <v-btn v-if="o.pejabat" color="orange" class="white--text" @click="add(o, 'ubah')">
                  Ubah
                </v-btn>
                <v-btn v-if="o.pejabat" color="red" class="white--text" @click="hapusPengurus(o)">
                  Hapus
                </v-btn>
                <v-btn v-if="o.pejabat" color="info" class="white--text" @click="previewKTA(o)">
                  Preview
                </v-btn>
                <!-- <v-menu v-if="o.pejabat && o.pejabat.warga" bottom offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn :disabled="o.pejabat.warga.is_generate_kta == 0" href="" v-bind="attrs" v-on="on" class="elevation-7 text-capitalize white--text teal darken-1 mx-3">
                      UNDUH <v-icon class="ml-2" small color="white">mdi-arrow-down-drop-circle-outline</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="downloadKTP(o.pejabat.warga)">
                      <v-list-item-title class=" purple--text text--darken-4">KTP</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="downloadKTA(o.pejabat.warga)">
                      <v-list-item-title class=" purple--text text--darken-4">KTA</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="downloadKTPKTA(o.pejabat.warga)">
                      <v-list-item-title class=" purple--text text--darken-4">KTP KTA</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu> -->
                <v-btn v-else color="info" class="white--text" @click="add(o)">
                  Tambah
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <!-- <v-layout row wrap>
          <v-flex xs4 class="my-2">
            <v-card class="primary flexcard" height="100%">
              <v-card-text class="grow"
                >Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi sit amet risus eget massa porttitor scelerisque in vitae dolor. Pellentesque finibus fermentum nunc,
                vitae facilisis erat rutrum eu. Nam sollicitudin hendrerit vehicula. Ut eleifend ornare augue, ac vehicula ligula aliquet vitae. Cras imperdiet quam ligula, non
                pharetra lacus aliquam sed. Nam eget ante sit amet diam sodales maximus vel et turpis. Sed dui tellus, pulvinar aliquam viverra nec, suscipit quis nulla. Praesent
                lacinia ut tortor at feugiat. Etiam tristique, diam eget viverra hendrerit, nibh quam commodo mi, a mollis dolor lacus vitae nunc. Quisque maximus posuere
                scelerisque. Duis pretium nunc a sem efficitur ultrices. Mauris lacinia metus ac urna consequat fermentum.</v-card-text
              >
              <v-card-actions>
                <v-btn flat>subscribe</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
          <v-flex xs4 class="my-2">
            <v-card class="primary flexcard" height="100%">
              <v-card-text class="grow">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</v-card-text>
              <v-card-actions>
                <v-btn flat>subscribe</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout> -->
      </v-col>
      <ChangeDlg ref="dlg" />
      <PreviewDlg ref="previewDlg" />
    </v-row>
  </v-container>
</template>

<script>
const lc = window.localStorage;
const TOKEN = "siapbbjatimtoken";
import ChangeDlg from "../../pengurus/components/Form.vue";
import FilterPengurus from "@/filter/FilterPengurus.vue";
import BlockCard from "@/components/BlockCard";
import PreviewDlg from "../../pengurus/components/Preview.vue";

export default {
  components: {
    ChangeDlg,
    FilterPengurus,
    BlockCard,
    PreviewDlg
  },
  data() {
    return {
      item: {
        jabatan: []
      },
      openfilter: [1, 2, 3, 4],
      items: [],
      filtered: {
        propinsi_id: null,
        kota_id: null,
        kecamatan_id: null,
        kelurahan_id: null
      },
      wilayah: null,
      tingkat: null,
      itemMapels: [],
      peran: null,
      textSearch: null,
      page: null,
      cp: 1,
      headers: [{ text: "", align: "left", value: "" }, { text: "", align: "left", value: "" }, { text: "", align: "left", value: "" }, { text: "", sortable: false }],
      more_menu: [
        // eslint-disable-next-line
        {
          title: "Detil Anggota",
          click: (i, o) => this.getDetil(o)
        },
        {
          title: "Ubah",
          click: (i, o) => this.edit(o),
          check: (i, o) => o.nomer_anggota == "" && !(this.current_user.peran && this.current_user.peran.id == 2)
        },
        {
          title: "Hapus",
          click: (i, o) => this.hapus(o),
          check: (i, o) => o.nomer_anggota == ""
        }
      ]
    };
  },
  mounted() {
    this.wilayah = this.current_user && this.current_user.lingkup.id;
    this.tingkat = this.current_user && this.current_user.lingkup.tingkat;
    this.load();
  },
  methods: {
    load() {
      return this.$store
        .dispatch("pengurus/get", {
          params: {
            wilayah_id: this.wilayah,
            tingkat: this.tingkat
          }
        })
        .then(res => {
          this.item = res;
        })
        .catch(e => e);
    },
    rekapKota() {
      var token = lc.getItem(TOKEN);
      return this.$store
        .dispatch("laporan/pengurusRekapKota", {
          params: {
            access_token: token
          }
        })
        .catch(e => e);
    },
    rekapKecamatan() {
      var token = lc.getItem(TOKEN);
      return this.$store
        .dispatch("laporan/pengurusRekapKecamatan", {
          params: {
            access_token: token
          }
        })
        .catch(e => e);
    },
    previewKTA(item) {
      this.$refs.previewDlg.open(item).then(() => {
        this.load();
      });
    },

    cekStatus(val){
      switch (val){
        case 1:
          return "PBB"
        case 2:
          return "Ganda"
        case 3:
          return "Partai Lain"
        default:
          return "Belum terdaftar"
      }

    },

    cetakZIP(level) {
      var token = lc.getItem(TOKEN);

      if (level == "pusat") {
        return this.$store.dispatch("pengurus/downloadPengurusZIP", {
          url: "jabatan_pusat_zip",
          params: {
            access_token: token,
            propinsi_id: this.filtered.propinsi_id,
            kota_id: this.filtered.kota_id,
            kecamatan_id: this.filtered.kecamatan_id,
            kelurahan_id: this.filtered.kelurahan_id
          }
        });
      }

      if (level == "propinsi") {
        return this.$store.dispatch("pengurus/downloadPengurusZIP", {
          url: "jabatan_propinsi_zip",
          params: {
            access_token: token,
            propinsi_id: this.filtered.propinsi_id,
            kota_id: this.filtered.kota_id,
            kecamatan_id: this.filtered.kecamatan_id,
            kelurahan_id: this.filtered.kelurahan_id
          }
        });
      }

      if (level == "kota") {
        // if (this.filtered.propinsi_id) {
        return this.$store
          .dispatch("pengurus/downloadPengurusZIP", {
            url: "jabatan_kota_zip",
            params: {
              access_token: token,
              propinsi_id: this.filtered.propinsi_id,
              kota_id: this.filtered.kota_id,
              kecamatan_id: this.filtered.kecamatan_id,
              kelurahan_id: this.filtered.kelurahan_id
            }
          })
          .catch(e => e);
        // } else {
        //   this.$error("Anda harus memilih Propinsi untuk unduh data ini");
        // }
      }

      if (level == "kecamatan") {
        // if (this.filtered.kota_id) {
        return this.$store
          .dispatch("pengurus/downloadPengurusZIP", {
            url: "jabatan_kecamatan_zip",
            params: {
              access_token: token,
              propinsi_id: this.filtered.propinsi_id,
              kota_id: this.filtered.kota_id,
              kecamatan_id: this.filtered.kecamatan_id,
              kelurahan_id: this.filtered.kelurahan_id
            }
          })
          .catch(e => e);
        // } else {
        //   this.$error("Anda harus memilih Kota/Kabupaten untuk unduh data ini");
        // }
      }
    },

    filter(data) {
      this.filtered = data;
      if (this.filtered.kelurahan_id) {
        this.wilayah = this.filtered.kelurahan_id;
        this.tingkat = 5;
      } else if (this.filtered.kecamatan_id) {
        this.wilayah = this.filtered.kecamatan_id;
        this.tingkat = 4;
      } else if (this.filtered.kota_id) {
        this.wilayah = this.filtered.kota_id;
        this.tingkat = 3;
      } else if (this.filtered.propinsi_id) {
        this.wilayah = this.filtered.propinsi_id;
        this.tingkat = 2;
      } else {
        this.wilayah = this.current_user && this.current_user.lingkup.id;
        this.tingkat = this.current_user && this.current_user.lingkup.tingkat;
      }
      this.load();
    },

    getDetil(item) {
      this.$refs.detailDlg.open(item);
    },
    add(o, isEdit) {
      this.$refs.dlg.open(o, this.wilayah, this.tingkat, isEdit).then(() => {
        this.load();
      });
    },
    hapusPengurus(item) {
      this.$confirm(`Apakah Anda yakin akan menghapus data pengurus ini ?<br>`)
        .then(() => {
          this.$store
            .dispatch("pengurus/dropPengurus", { wilayah_id: this.wilayah, item: item })
            .then(() => {
              this.$info("Data Pengurus berhasil diunduh");
            })
            .then(() => this.load())
            .catch(e => e);
        })
        .catch(e => e);
    },
    downloadKTP(item) {
      this.$confirm(
        `Apakah Anda yakin akan mencetak KTP ?<br>
        <div class="mt-2 title grow text-center">
           ${item.nama} <br>
        </div>
      `
      )
        .then(() => {
          // window.open(this.preview.kta_pdf.origin, "_blank");
          this.$store
            .dispatch("pengurus/cetakKTP", item.ktp.origin)
            .then(() => {
              this.$info("Data berhasil diunduh");
            })
            .then(() => this.load())
            .catch(e => e);
        })
        .catch(e => e);
    },
    downloadKTA(item) {
      this.$confirm(
        `Apakah Anda yakin akan mencetak KTA ?<br>
        <div class="mt-2 title grow text-center">
           ${item.nama} <br>
        </div>
      `
      )
        .then(() => {
          // window.open(this.preview.kta_pdf.origin, "_blank");
          this.$store
            .dispatch("pengurus/cetak", item.kta_pdf.origin)
            .then(() => {
              this.$info("Data berhasil diunduh");
            })
            .then(() => this.load())
            .catch(e => e);
        })
        .catch(e => e);
    },
    downloadKTPKTA() {
      this.$confirm(
        `Apakah Anda yakin akan mencetak KTP KTA di wilayah ini ?<br>
        <div class="mt-2 title grow text-center">

        </div>
      `
      )
        .then(() => {
          // window.open(this.preview.kta_pdf.origin, "_blank");
          this.$store
            .dispatch("warga/cetakMasalPengurus", this.wilayah)
            .then(() => {
              this.$info("Data berhasil diunduh");
            })
            .then(() => this.load())
            .catch(e => e);
        })
        .catch(e => e);
    },
    edit(item) {
      this.$refs.dlg.open(item).then(() => {
        this.load();
      });
    },
    link(item) {
      window.open(item.link, "_blank");
    },
    hapus(item) {
      this.$confirm(
        `Apakah Anda yakin akan menghapus data pengurus ini ?<br>
        <div class="mt-2 title grow text-center">
          ${item.nama}<br>
        </div>`,
        {
          cancelOnly: item.laporan_accepted_count > 0 ? true : false
        }
      )
        .then(() => this.$store.dispatch("pengurus/drop", item))
        .then(() => {
          this.$info("Data Anggota " + item.nama + " berhasil dihapus");
        })
        .then(() => this.load())
        .catch(e => e);
    }
  },
  watch: {}
};
</script>
<style>
.flexcard {
  display: flex;
  flex-direction: column;
}
</style>
